module.exports = __webpack_public_path__ + "img/ring_g_l_null_1@3x.2f7c88f8.png";